import { render, staticRenderFns } from "./AddFields.vue?vue&type=template&id=af4edba6&scoped=true"
import script from "./AddFields.vue?vue&type=script&lang=js"
export * from "./AddFields.vue?vue&type=script&lang=js"
import style0 from "./AddFields.vue?vue&type=style&index=0&id=af4edba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4edba6",
  null
  
)

export default component.exports